import { createSlice, createAsyncThunk, createAction } from '@reduxjs/toolkit';
import getInitialState, { resetData } from '../../../store/initial_state';
import { getAlbumsPhotos, getSharedSingleAlbumInfo } from "../../single_album_view/meta/slices"
import { sharedAlbumsLimit } from "./selectors";

/* global photoOrg, eventBus */

export const albumsDataReset = createAction('albums/reset');
export const unSelectedAlbumData = createAction("albums/resetUnSelectedAlbumData");
export const removeSelectedAlbumData = createAction('albums/selectedAlbumRemove');

export const fetchOwnedAlbumList = createAsyncThunk(
    "albums/fetchOwnedAlbumListRes",
    async (config, { rejectWithValue }) => {
      try {
        const params ={
            skip: 0,
            limit: 5,
            timezoneOffset: config.timeZoneOffset,
            clustersPerPage: config.clustersPerPage
        };
        
        //picking sort criteria and sortorder
        if(config.sortCriteria){
            params.sortCriteria = config.sortCriteria
        }    
        if(config.sortOrder){//if sortOrder is updateDate(Recently Modified) then picking descending order for the lastest date to be visible first
            params.sortOrder = (params.sortCriteria === "updateDate")? "descending" : config.sortOrder;
        }
        const albumsClusterMetaData = await photoOrg.albumDataManager.getAlbumsClusterMetaData(params)
            .then((response) => {
               eventBus.trigger(eventBus.CUSTOM_EVENT_BIND_SOURCE_BAR_EVENTS,{});
               return {"pages": response.pages, "clusters": response.firstPageData.clusters};
            },(err)=>{
              const errorObj = Object.assign({description: "LIBRARY:Slices:fetchownedAlbumList:Exception", errorCode: "LIBRARY:MYPHOTOS"},err)
              photoOrg.clientLogger.error(errorObj);
              //TODO: need to handle error state
              photoOrg.AlbumFetcher.onError(err);
            });

            console.log("albumsClusterMetaData=",albumsClusterMetaData)
        return albumsClusterMetaData;
      } catch (err) {
        photoOrg.clientLogger.error({description: "LIBRARY:Slices:albumsClusterMetaData:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
        return rejectWithValue([], err);
      }
    }
);

export const fetchCaptionSortAlbumList = createAsyncThunk(
    "albums/captionSortAlbumFetchListRes",
    async (config, { rejectWithValue }) => {
      try {
        const captionMinCollectionList = await photoOrg.albumDataManager.getAllCaptionMinCollectionList({
            sortOrder:config.sortOrder,
            minCollection: config.minCollection
        }).catch(function(err){
            photoOrg.clientLogger.error({
                description: "LIBRARY:Slices:fetchCaptionSortAlbumList:Exception",
                errorCode: "LIBRARY:ALBUM-SLICES",
                err_desc: err,
                err_stack: err.stack,
              });
        });
        console.log("captionMinCollectionList=",captionMinCollectionList)
        return captionMinCollectionList;
      } catch (err) {
        photoOrg.clientLogger.error({description: "LIBRARY:Slices:captionMinCollectionList:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
        return rejectWithValue([], err);
      }
    }
  );

export const getPageClustersList = createAsyncThunk(
    "albums/getPageClustersRes",
    async (config, { rejectWithValue }) => {
      try {
        const requestUrl = config.url;
        const getAlbumClustersData = await photoOrg.albumDataManager.getAlbumClusters(requestUrl)
        .then((response) => {
            if (!response) {
                photoOrg.clientLogger.error({description: "AlbumFetcher::getPageClusters got empty album info", response: response});
                return;
            }
            return response.data;
        }).catch(function(err){
            photoOrg.AlbumFetcher.onError(err);
        });
        return getAlbumClustersData;
      } catch (err) {
        photoOrg.clientLogger.error({description: "LIBRARY:Slices:getAlbumClustersData:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
        return rejectWithValue([], err);
      }
    }
);

export const deleteIndividualAlbum = createAsyncThunk(
    "albums/deleteAlbum",
    async (config, {rejectWithValue }) =>{
      try{
        const params = {
          albumId : config.albumId,
          projection: config.projection
        }
        const albumResponse = await photoOrg.albumDataManager.deleteAlbum(params)
        .then((response) => {
          if (!response.data) {
            photoOrg.clientLogger.error({description: "deleteIndividualAlbum::albumResponse got delete api failed", response: response});
            return;
          }
          return response.data;
        }).catch(function(err){
          photoOrg.AlbumFetcher.onError(err);
        });
        return albumResponse;

      } catch (err){
        photoOrg.clientLogger.error({description: "LIBRARY:Slices:deleteIndividualAlbum:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
        return rejectWithValue([], err);
      }
    }
);

export const deleteFrinedsIndividualAlbum = createAsyncThunk(
  "albums/deleteFriendsAlbum",
  async (config, {rejectWithValue }) =>{
    try{
      const albumResponse = await photoOrg.shareDataManager.deleteSocialAlbum(config)
      .then((response) => {
        if (!response.data) {
          photoOrg.clientLogger.error({description: "deleteFrinedsIndividualAlbum::albumResponse got delete api failed", response: response});
          return;
        }
        return response.data;
      }).catch(function(err){
        photoOrg.AlbumFetcher.onError(err);
      });
      return albumResponse;

    } catch (err){
      photoOrg.clientLogger.error({description: "LIBRARY:Slices:deleteFrinedsIndividualAlbum:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
      return rejectWithValue([], err);
    }
  }
);

export const getMySharedAlbumsList = createAsyncThunk(
    "albums/getMySharedAlbumsResponse",
    async (config, { rejectWithValue }) => {
      try {
        const getMySharedAlbumsData = await photoOrg.shareDataManager.getSocialAlbumsInfo(config)
        .then((response) => {
            if (!response) {
                photoOrg.clientLogger.error({description: "Slices::getMySharedAlbumsList got empty album info", response: response});
                return;
            }
            console.log("mysharedresponse", response.data);
            return response.data;
        }).catch(function(err){
            photoOrg.AlbumFetcher.onError(err);
        });
        return getMySharedAlbumsData;
      } catch (err) {
        photoOrg.clientLogger.error({description: "LIBRARY:Slices:getMySharedAlbumsData:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
        return rejectWithValue([], err);
      }
    }
);

export const getMyFriendsAlbumsList = createAsyncThunk(
  "albums/getMyFriendsAlbumsResponse",
  async (config, { rejectWithValue }) => {
    try { 
      const getMyFriendslbumsData = await photoOrg.shareDataManager.getSocialAlbumsInfo(config)
      .then((response) => {
          if (!response) {
              photoOrg.clientLogger.error({description: "Slices::getMyFriendsAlbumsList got empty album info", response: response});
              return;
          }
          console.log("getMyFriendsAlbumsList", response.data);
          return response.data;
      }).catch(function(err){
          photoOrg.AlbumFetcher.onError(err);
      });
      return getMyFriendslbumsData;
    } catch (err) {
      photoOrg.clientLogger.error({description: "LIBRARY:Slices:getMyFriendsAlbumsList:Exception", errorCode: "LIBRARY:ALBUMVIEW", err_desc: err.message, err_stack: err.stack});
      return rejectWithValue([], err);
    }
  }
);

export const fetchNextSetOfAlbums = createAsyncThunk(
  'album/fetchNextSetOfAlbums',
  async ({ clusterKey, clusterIndex, sortOrder }, { getState }) => {
    const state = getState().album.albumView;
    const currentCluster = state.currentClusterName;
    let currentAlphabetIndex = state.currentAlphabetIndex || 0;
    let showViewLess = state.showViewLess;
    let albumsToFetch = 50; // We always fetch 50 albums per API call
    let skip = state.skip || 0; // Keep track of how many albums have been skipped
    let newClusterAlbumsArr = state.clusterAlbumsArr.slice();
    let newCacheArr = state.cacheArr.slice();
    const jumpToModuleData = getState().album.captionSortAlbums.data.jumpToModuleData;
    const selectedJumpToModule = jumpToModuleData[clusterIndex][clusterKey];
    const initialResponseData = getState().album.captionSortAlbums.data.initialResponse.entityMap;
    const totalAlbumsDisplayed = getState().album.captionSortAlbums.data.collectionListRes[clusterKey].entities.length;
    const clusterCount = getState().album.captionSortAlbums.data.collectionListRes[clusterKey].count;
    const currentAlpha = selectedJumpToModule[state.currentAlphabetIndex];
    const currentAlphaCount = parseInt(initialResponseData[`'${currentAlpha}'`]?.collectionCount) || 0;
    let adjustedTotalAlbumsDisplayed = totalAlbumsDisplayed;
    // Check if the cluster has changed and it's not the initial state
    if (currentCluster && currentCluster !== clusterKey) {
      // Reset state if the cluster has changed
      newClusterAlbumsArr = getState().album.captionSortAlbums.data.collectionListRes[clusterKey].entities.slice(0, 9);
      newCacheArr = [];
      currentAlphabetIndex = 0;
      skip = 0;
      showViewLess = false;
      adjustedTotalAlbumsDisplayed = 9;
    }

    let nextAlbumCount = getOddAlbumCount(adjustedTotalAlbumsDisplayed);

    // Helper function to get the count of albums for a specific alphabet
    const getAlbumCountForAlphabet = (alphabet) => {
      return parseInt(initialResponseData[`'${alphabet}'`]?.collectionCount) || 0;
    };

    // Helper function to render the albums from cache
    const appendAlbumsFromCache = (targetArr, sourceArr, requiredCount) => {
      const extractedAlbums = sourceArr.slice(0, requiredCount);
      targetArr.push(...extractedAlbums);
      sourceArr.splice(0, requiredCount); // Removing the extracted albums from the source array
    };

    while (newClusterAlbumsArr.length < nextAlbumCount && currentAlphabetIndex < selectedJumpToModule.length) {
      const currentAlpha = selectedJumpToModule[currentAlphabetIndex];
      const currentAlphaCount = getAlbumCountForAlphabet(currentAlpha);

      if (skip >= currentAlphaCount) {
        // Move to the next alphabet if we have skipped all albums of the current alphabet
        currentAlphabetIndex++;
        skip = 0;
        continue;
      }
      const remainingToAdd = nextAlbumCount - newClusterAlbumsArr.length;
      
      // If we already have enough albums in the cache, use them
      if (newCacheArr.length > 0) {
        appendAlbumsFromCache(newClusterAlbumsArr, newCacheArr, remainingToAdd);
        if (newClusterAlbumsArr.length >= nextAlbumCount) break;
      }
      if (currentAlphaCount <= 9) {
        // If currentAlphaCount is less than or equal to 9, fetch albums from initialResponseData
        const initialAlbums = initialResponseData[`'${currentAlpha}'`].collectionList;
        for (let album of initialAlbums) {
          if (newClusterAlbumsArr.length < nextAlbumCount) {
            const albumExists = newClusterAlbumsArr.some(a => a.id === album.id);
            if (!albumExists) {
              newClusterAlbumsArr.push(album);
            }
          } else {
            newCacheArr.push(album);
          }
        }
        currentAlphabetIndex++;
      }else{
        // Fetch more albums from API
        const response = await photoOrg.albumDataManager.getCaptionLetterSpecificCollectionList({
          captionAlphabetName: currentAlpha,
          skip: skip,
          limit: albumsToFetch,
          sortOrder: sortOrder,
          minCollection: albumsToFetch,
        });
        const fetchedAlbums = response.data.entities;

        // Add fetched albums to the cluster album array, ensuring no duplicates
        for (let album of fetchedAlbums) {
          if (newClusterAlbumsArr.length < nextAlbumCount) {
            const albumExists = newClusterAlbumsArr.some(a => a.id === album.id);
            if (!albumExists) {
              newClusterAlbumsArr.push(album);
            }
          } else {
            newCacheArr.push(album);
          }
        }

        skip += albumsToFetch;
        
        if (fetchedAlbums.length < albumsToFetch) {
          // If fewer albums were fetched than requested, move to the next alphabet
          currentAlphabetIndex++;
          skip = 0;
        }}
      }

    // Check if we have finished fetching albums
    if (newClusterAlbumsArr.length + newCacheArr.length >= clusterCount && newClusterAlbumsArr.length != nextAlbumCount) {
      appendAlbumsFromCache(newClusterAlbumsArr, newCacheArr, clusterCount - newClusterAlbumsArr.length);
      showViewLess = true;
    }else if(currentAlphabetIndex === selectedJumpToModule.length && newCacheArr.length === 0 && newClusterAlbumsArr.length === nextAlbumCount){
      showViewLess = true;
    }
    return {
      clusterKey,
      clusterAlbumsArr: newClusterAlbumsArr,
      cacheArr: newCacheArr,
      skip,
      currentAlphabetIndex,
      showViewLess,
      clusterCount
    };
  }
);

// Helper function to get the next odd number to render the albums in odd format
const getOddAlbumCount = (currentCount) => {
  if (currentCount < 9) return 9;
  let total = 9;
  let increment = 16;
  while (total <= currentCount) {
    total += increment;
    increment = 24; // After the first increment, always add 24 to the previous count
  }
  return total;
};



const getFormattedResponseDataForAlbumsView = (response,isMyShared,payload, meta) =>{
  try {
      let data = JSON.parse(JSON.stringify(response));
      if (!(data && data.entities && data.entities.length > 0))
          return data;
      //mocking data to display temporarily
      data.resultCount = data.entities.length;
      for (var i = 0; i < data.resultCount; i++) {
          //data.entities[i].createDate = data.entities[i].createDate;
          data.entities[i].accessLevel = "OWNER";
          data.entities[i].userTags = [
              {"value": data.entities[i].caption, "key": "caption"}
          ];
          // to display count temporarily
          data.entities[i].assetIdList = [];
          //type is used for many operations for aggr user so it should be present for non aggr as well.
          //It cannot be set in the pascal code, therefore adding the change at front end.
          if(isMyShared === true){
            data.entities[i].type = "shared";
          }else{
            data.entities[i].type = "received";
          }
      }
      return data;
  } catch (e) {
      photoOrg.clientLogger.error({description: "LIBRARY:SharedAlbumsComponent:getFormattedResponseDataForAlbumsView:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e, err_stack: e.stack, response: JSON.stringify(payload), meta : JSON.stringify(meta)});
  }
}

  const albumsSlice = createSlice({
    name: "albums",
    initialState: getInitialState(),
    reducers: {

      updateAlbumViewState: (state, action) => {
        const { currentAlphabetKey} = action.payload;
        state.captionSortAlbums.data.collectionListRes[currentAlphabetKey].entities.length = 9;
        state.albumView.showViewLess = false;
        state.albumView.cacheArr = [];
        state.albumView.clusterAlbumsArr = [];
        state.albumView.currentAlphabetIndex = 0;
        state.albumView.skip = 0;
      },

    },
    extraReducers: (builder) => {
        builder.addCase(fetchOwnedAlbumList.fulfilled, (state, { meta, payload, type }) => {
            //if (meta.requestId === state.onwedAlbums.currentRequestId.requestId) {
              state.onwedAlbums.data = payload;
              state.onwedAlbums.loading = "success";
              state.onwedAlbums.currentRequestId = "";
              state.onwedAlbums.pageNo = meta.arg.pageNo;
              console.log(type);
            
        })
        builder.addCase(fetchOwnedAlbumList.pending, (state, { meta }) => {
            state.onwedAlbums.currentRequestId = meta;
            state.onwedAlbums.sortOrder = meta.arg.sortOrder;
            state.onwedAlbums.sortCriteria = meta.arg.sortCriteria;
            state.onwedAlbumsLoading = "pending";
        })
        builder.addCase(fetchOwnedAlbumList.rejected, (state, { meta, payload, error }) => {
            if (meta.requestId === state.onwedAlbums.currentRequestId.requestId) {
                state.onwedAlbums.currentRequestId = meta;
                state.onwedAlbums.loading = "failed";
                state.onwedAlbums.data = payload;
                state.onwedAlbums.error = error;
            }
        })
        
        builder.addCase(fetchCaptionSortAlbumList.fulfilled, (state, { meta, payload }) => {
            if (meta.requestId === state.captionSortAlbums.currentRequestId.requestId) {
                state.captionSortAlbums.data = payload.data;
                state.captionSortAlbums.loading = "success";
                state.captionSortAlbums.currentRequestId = "";                
            }
        })
        builder.addCase(fetchCaptionSortAlbumList.pending, (state, { meta }) => {
            state.captionSortAlbums.currentRequestId = meta;
            state.captionSortAlbums.loading = "pending";
            state.captionSortAlbums.sortOrder = meta.arg.sortOrder;
        })
        builder.addCase(fetchCaptionSortAlbumList.rejected, (state, { meta, payload, error }) => {
            if (meta.requestId === state.captionSortAlbums.currentRequestId.requestId) {
                state.captionSortAlbums.currentRequestId = meta;
                state.captionSortAlbums.loading = "failed";
                state.captionSortAlbums.data = payload;
                state.captionSortAlbums.error = error;
            }
        })

        //to handle jumpTo or scroll - scroll needs to append else if jumpTo replace
        builder.addCase(getPageClustersList.fulfilled, (state, { meta, payload }) => {
            //removed comparing the rquest id with state currentRequestId as its getting overriding with loop dispatch calls
            //if (meta.requestId === state.onwedAlbums.currentRequestId.requestId) {
              if(meta.arg.bottomScrolling || (meta.arg.isJumptoMonth && meta.arg.append)){
                state.onwedAlbums.data.clusters = {...state.onwedAlbums.data.clusters, ...payload.clusters };
              }else if(meta.arg.topScrolling){
                state.onwedAlbums.data.clusters = {...payload.clusters, ...state.onwedAlbums.data.clusters };
              }else if(meta.arg.isJumptoMonth && !meta.arg.append){
                state.onwedAlbums.data.clusters = payload.clusters;
              }
              state.onwedAlbums.pageNo = meta.arg.pageNo;
              state.onwedAlbums.loading = "success";
              state.onwedAlbums.currentRequestId = "";
           // }
        })
        builder.addCase(getPageClustersList.pending, (state, { meta }) => {
            state.onwedAlbums.currentRequestId = meta;
            state.onwedAlbumsLoading = "pending";
        })
        builder.addCase(getPageClustersList.rejected, (state, { meta, payload, error }) => {
            if (meta.requestId === state.onwedAlbums.currentRequestId.requestId) {
                state.onwedAlbums.currentRequestId = meta;
                state.onwedAlbums.loading = "failed";
                state.onwedAlbums.data = payload;
                state.onwedAlbums.error = error;
            }
        })
        builder.addCase(deleteIndividualAlbum.pending, (state, { meta }) => {
            //having problem updating this line in fullfilled state as only clean up will execute on useEffect Ref setting
            state.deletedAlbumsArr.push(meta.arg.albumId);
        })
        builder.addCase(deleteIndividualAlbum.fulfilled, (state, { meta, payload, type }) => {
          if(meta.arg.isMySharedDeleteAlbum){
            console.log(current(state.mySharedAlbums.data.entities));
            console.log(meta.arg.albumId);
            state.mySharedAlbums.data.entities = state.mySharedAlbums.data.entities.filter(albObj =>{
              return albObj.id !== meta.arg.albumId
            });
          }else{
            if (meta.arg.sortCriteria === "caption"){
              state.captionSortAlbums.data.collectionListRes[meta.arg.monthNYearKey].entities = state.captionSortAlbums.data.collectionListRes[meta.arg.monthNYearKey].entities.filter(album =>{
                return album.id !== parseInt(meta.arg.albumId)
              })
              if(state.captionSortAlbums.data.collectionListRes[meta.arg.monthNYearKey].entities.length === 0){
                delete state.captionSortAlbums.data.collectionListRes[meta.arg.monthNYearKey];
              }
            }else{
              //console.log(current(state.onwedAlbums.data.clusters));
              state.onwedAlbums.data.clusters[meta.arg.monthNYearKey]= state.onwedAlbums.data.clusters[meta.arg.monthNYearKey].filter(data =>{
                return data.album.albumId !== meta.arg.albumId
              })
              if(state.onwedAlbums.data.clusters[meta.arg.monthNYearKey].length === 0){
                delete state.onwedAlbums.data.clusters[meta.arg.monthNYearKey];
              }
            }
          }   
        })
        builder.addCase(deleteIndividualAlbum.rejected, (state, { meta, payload, error }) => {
            state.deletedAlbumsArr = state.deletedAlbumsArr.filter(function(value){ 
              return value != meta.arg.albumId;
            });
        })

        builder.addCase(deleteFrinedsIndividualAlbum.pending, (state, { meta }) => {
          //having problem updating this line in fullfilled state as only clean up will execute on useEffect Ref setting
          state.deletedAlbumsArr.push(meta.arg.albumId);
        })
        builder.addCase(deleteFrinedsIndividualAlbum.fulfilled, (state, { meta, payload, type }) => {
          console.log(current(state.myFriendsAlbums.data.entities));
          console.log(meta.arg.albumId);
          state.myFriendsAlbums.data.entities = state.myFriendsAlbums.data.entities.filter(albObj =>{
            return albObj.id !== meta.arg.albumId
          })
        })
        builder.addCase(deleteFrinedsIndividualAlbum.rejected, (state, { meta, payload, error }) => {
          state.deletedAlbumsArr = state.deletedAlbumsArr.filter(function(value){
            return value != meta.arg.albumId;
          });
        })

        builder.addCase(getMySharedAlbumsList.fulfilled, (state, { meta, payload, type }) => {
          //if (meta.requestId === state.mySharedAlbums.currentRequestId.requestId) {
            const isMyShared = true;
            if(parseInt(meta.arg.skip) >= sharedAlbumsLimit && state.mySharedAlbums.data && state.mySharedAlbums.data.entities){
              state.mySharedAlbums.data.entities = [...state.mySharedAlbums.data.entities, ...getFormattedResponseDataForAlbumsView(payload.albumsInfo,isMyShared,payload,meta).entities ];
            }else{
              state.mySharedAlbums.data.entities = getFormattedResponseDataForAlbumsView(payload.albumsInfo,isMyShared,payload,meta).entities;
              //console.log(current(state.mySharedAlbums));
            }
            state.mySharedAlbums.data.resultCount = payload.albumsInfo.entities.length;
        })
        builder.addCase(getMySharedAlbumsList.rejected, (state, { meta, payload, error }) => {  
            state.mySharedAlbums.error = error;
        })

        builder.addCase(getMyFriendsAlbumsList.fulfilled, (state, { meta, payload, type }) => {
          const isMyShared = false;
          if(state.myFriendsAlbums.data.entities && state.myFriendsAlbums.data.entities.length >= 0){
            state.myFriendsAlbums.data.entities = [...state.myFriendsAlbums.data.entities,...getFormattedResponseDataForAlbumsView(payload.albumsInfo,isMyShared,payload,meta).entities];
          }else{
            state.myFriendsAlbums.data.entities = getFormattedResponseDataForAlbumsView(payload.albumsInfo,isMyShared,payload,meta).entities;
          }
          state.myFriendsAlbums.data.resultCount = payload.albumsInfo.entities.length;
        })
        builder.addCase(getMyFriendsAlbumsList.rejected, (state, { meta, payload, error }) => {  
            state.myFriendsAlbums.error = error;
        })

        builder.addCase(getAlbumsPhotos.fulfilled, (state, { meta, payload }) => {
          if(meta.arg.deSelectAlbum){
            state.allAlbumPicInfo.unSelectedAlbums.currentUnselectedAlbumPicInfo = payload.entities;
          }else{
            state.allAlbumPicInfo.selectedAlbums.data[meta.arg.albumId] = payload;
          }
        })

        builder.addCase(getSharedSingleAlbumInfo.fulfilled, (state, { meta, payload }) => {
          if(meta.arg.deSelectAlbum){
            state.allAlbumPicInfo.unSelectedAlbums.currentUnselectedAlbumPicInfo = payload.entities;
          }else{
            state.allAlbumPicInfo.selectedAlbums.data[meta.arg.albumId] = payload;
          }
        })
      
        builder.addCase(removeSelectedAlbumData, (state, action) => {
          if(action.payload === true){
             state.allAlbumPicInfo.selectedAlbums.data = {};
          }else{
            delete state.allAlbumPicInfo.selectedAlbums.data[action.payload];
          }
          return state;
        })

        builder.addCase(unSelectedAlbumData, (state, action) =>{
          if (state.allAlbumPicInfo.unSelectedAlbums.currentUnselectedAlbumPicInfo.length > 0){
            state.allAlbumPicInfo.unSelectedAlbums.currentUnselectedAlbumPicInfo = [];
          }
          return state;
        })

       builder.addCase(fetchNextSetOfAlbums.fulfilled, (state, { payload }) => {
          const { clusterKey, clusterAlbumsArr, cacheArr, skip, currentAlphabetIndex, showViewLess, clusterCount } = payload;
          console.log("clusterCount", clusterCount);
          console.log("rendered Albums",clusterAlbumsArr);
          state.albumView.clusterAlbumsArr = clusterAlbumsArr;
          state.captionSortAlbums.data.collectionListRes[clusterKey].entities = clusterAlbumsArr;
          state.albumView.cacheArr = cacheArr;
          state.albumView.skip = skip;
          state.albumView.currentClusterName = clusterKey;
          state.albumView.currentAlphabetIndex = currentAlphabetIndex;
          state.albumView.showViewLess = showViewLess;
        });
  
        builder.addCase(albumsDataReset, (state, action) => {
          resetData(state);
          console.log("action=",action,"state=",state);
          return state;
        })
      },
  });

  export const { updateAlbumViewState } = albumsSlice.actions;
  export const { actions, reducer } = albumsSlice;
  export default reducer;